import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from './../../../services/application/login.service';

@Component({
    selector: 'app-sso',
    templateUrl: './sso.component.html',
    standalone: false
})
export class SsoComponent implements OnInit {
  public loading = false;
  public error: string = null;

  constructor(private readonly _router: Router,
              private readonly route: ActivatedRoute,
              private readonly _loginService: LoginService) { }

  ngOnInit(): void {
    const AUTH_CODE = this.route.snapshot.queryParams?.code;
    if (AUTH_CODE) {
      this._loginService.loginUserWithOAuthCode(AUTH_CODE).then(() => {
        this._router.navigate(['/overview']);
      })
      .catch(() => {
        this.getRedirectUrl().then(externalURL => {
          window.location.href = externalURL;
        });
      });
    } else {
      this.getRedirectUrl().then(externalURL => {
        window.location.href = externalURL;
      });
    }
  }

  private async getRedirectUrl(): Promise<string> {
    return Promise.resolve(this._loginService.generateRedirectLoginUrl());
  }
}
